// extracted by mini-css-extract-plugin
export default {"skeletWrapper":"SportsSliderSkelet_skeletWrapper--mqT","skelet":"SportsSliderSkelet_skelet--qiH"};